/* cl-interactions.js — devolve vida ao que era JS do tema do concorrente.

   O `section_kit scope` copia HTML e CSS, mas o JavaScript do tema dele fica de fora
   (site-builder.md §5.4/§3). Sem isto as abas nao trocam, o acordeao nao abre, a galeria
   do produto nao anda e as setas do carrossel nao movem nada — o `verify` reprova em
   `interactions` e o visitante clica num site morto. Tudo aqui e delegado no document e
   restrito aos wrappers `.cl-sec-*`, entao nada toca o tema.

   RETRABALHO 2026-08-19 — o operador reprovou "os visuais que tem rolagem nao funcionam".
   O `step()` anterior so empurrava o `translateX` do slider por UMA largura de celula
   chutada, nao sabia em que slide estava, nao respondia a arrasto/swipe e ignorava as
   miniaturas. Agora existe um motor: cada `.flickity-viewport` congelado pelo extract e
   MEDIDO uma vez (posicao real de cada celula), classificado em `slide` ou `fade`, e
   passa a andar por setas, miniatura, teclado, arrasto de mouse e swipe. */
(function () {
  'use strict';

  var SEC = '[class*="cl-sec-"]';

  function root(el) {
    return el.closest(SEC);
  }

  function kids(el) {
    return [].filter.call(el.children, function (n) { return n.nodeType === 1; });
  }

  /* ---------------------------------------------------------------- abas ---
     Markup do Pipeline: `button.tab-link.tab-link-N` + `div.tab-content.tab-content-N`.
     O CSS copiado ja esconde `.tab-content:not(.current)`; so falta mover a classe. */
  function switchTab(link) {
    var box = root(link);
    if (!box) return;
    var m = /tab-link-(\d+)/.exec(link.className);
    if (!m) return;
    var n = m[1];
    box.querySelectorAll('.tab-link').forEach(function (b) {
      b.classList.toggle('current', b === link);
      if (b.hasAttribute('aria-selected')) b.setAttribute('aria-selected', String(b === link));
    });
    box.querySelectorAll('.tab-content').forEach(function (c) {
      c.classList.toggle('current', c.classList.contains('tab-content-' + n));
    });
    // um carrossel dentro de aba escondida mede 0 — remede ao aparecer
    setTimeout(scanCarousels, 60);
  }

  /* ----------------------------------------------------------- acordeao ---
     O estado vive em `aria-expanded` (e o que sobrevive ao restate) e o
     cl-overrides.css esconde/mostra o corpo irmao a partir dele. Alem da regra de CSS,
     escrevemos o `display` no PROPRIO corpo: o extract preserva o
     `style="display:none"` inline do concorrente, e style inline ganha de qualquer
     folha de estilo — sem isto o painel continuaria fechado por mais que a classe
     mudasse (era metade da reclamacao "collapsable vazio"). */
  var BODY_SEL = '.accordion__body, .collapsible__content, .faq__answer, [data-accordion-body]';

  /* ATENCAO: `document.getElementById` NAO serve aqui. Cada secao copiada existe DUAS
     vezes na pagina (`.cl-vd` do DOM desktop e `.cl-vm` do mobile — ver pagebuild.py), e
     as duas carregam os MESMOS ids do concorrente. O getElementById devolve sempre a
     primeira, que no mobile e a copia ESCONDIDA: o clique abria um painel invisivel e o
     visitante via o acordeao "abrir vazio" — exatamente a reclamacao do operador, so que
     no celular. A busca tem que ficar dentro do wrapper da variante clicada. */
  function bodiesOf(head) {
    var out = [];
    var scope = root(head) || document;
    var id = head.getAttribute('aria-controls') || head.getAttribute('data-accordion-trigger');
    if (id) {
      var byId = scope.querySelector('[id="' + id.replace(/"/g, '\\"') + '"]');
      if (byId) out.push(byId);
    }
    var sib = head.nextElementSibling;
    while (sib) {
      if (sib.matches && sib.matches(BODY_SEL) && out.indexOf(sib) === -1) out.push(sib);
      sib = sib.nextElementSibling;
    }
    return out;
  }

  function toggleAccordion(head) {
    if (isFooterHead(head) && window.innerWidth >= 768) return;  // no desktop nao colapsa
    var open = head.getAttribute('aria-expanded') === 'true';
    head.setAttribute('aria-expanded', String(!open));
    head.classList.toggle('accordion-is-open', !open);
    bodiesOf(head).forEach(function (b) {
      b.style.display = open ? 'none' : 'block';
      b.setAttribute('aria-hidden', String(open));
    });
  }

  /* O rodape so e acordeao ABAIXO de 768px (cl-overrides.css regra 10): no desktop as
     tres colunas ficam abertas mesmo com `aria-expanded="false"`. A marca esta na classe
     do PROPRIO cabecalho (`footer__accordion__head`) — nao existe ancestral
     `.footer__accordion`, e foi por isso que a primeira versao deste guarda-corpo nao
     pegou: o rodape colapsou no desktop e caiu de 0.98 para 0.44 em toda pagina. */
  function isFooterHead(head) {
    return /footer__accordion/.test(head.className || '');
  }

  /* Estado inicial: todo corpo cujo gatilho esta `aria-expanded="false"` nasce fechado,
     e o que esta "true" nasce aberto — inclusive os que o extract capturou abertos com
     `style="display:block"` inline. */
  function syncAccordions() {
    document.querySelectorAll(SEC + ' [aria-expanded][class*="accordion"], '
      + SEC + ' [aria-expanded][data-accordion-trigger]').forEach(function (head) {
      if (head.closest('[data-cl-pdp]')) return;
      if (isFooterHead(head) && window.innerWidth >= 768) return;
      var open = head.getAttribute('aria-expanded') === 'true';
      bodiesOf(head).forEach(function (b) {
        b.style.display = open ? 'block' : 'none';
      });
    });
  }

  /* ---------------------------------------------------------- carrossel ---
     O extract congela o flickity: as celulas ficam em `position:absolute` com o
     `transform` que o carrossel escreveu, o slider guarda um `translateX(N%)` de
     alinhamento e o JS que movia tudo isso nao veio junto.

     Medimos UMA vez, no estado congelado: a posicao de cada celula relativa ao viewport.
     Se todas caem no mesmo lugar, o carrossel e do tipo `fade` (a galeria da PDP no
     desktop e `is-fade` — as fotos se empilham e quem manda e a opacidade); se estao
     lado a lado, e `slide` e basta transladar o slider pela diferenca medida. */
  var CARS = [];
  /* Pares (janela, faixa) que o extract congela. O flickity e do tema do concorrente;
     o `hooper` vem dentro do widget de avaliacoes (Okendo) — o `verify` reprovava o
     carrossel de fotos dos clientes porque o clique em "Image suivante" nao movia nada. */
  var VIEW_SEL = '.flickity-viewport, .hooper-list';
  var TRACK_SEL = '.flickity-slider, .hooper-track';

  function build(view) {
    var slider = null;
    var cand = view.children;
    for (var i = 0; i < cand.length; i++) {
      if (cand[i].nodeType === 1 && cand[i].matches && cand[i].matches(TRACK_SEL)) {
        slider = cand[i];
        break;
      }
    }
    if (!slider) return null;
    var cells = kids(slider);
    if (cells.length < 2) return null;
    if (getComputedStyle(slider).display === 'contents') return null;  // virou scroller

    var base = slider.style.transform || '';
    var v = view.getBoundingClientRect();
    var lefts = cells.map(function (c) { return c.getBoundingClientRect().left - v.left; });
    var spread = Math.max.apply(null, lefts) - Math.min.apply(null, lefts);
    var mode = spread < 6 ? 'fade' : 'slide';
    var idx = 0;
    cells.forEach(function (c, i) { if (c.classList.contains('is-selected')) idx = i; });

    var car = { view: view, slider: slider, cells: cells, base: base, lefts: lefts,
                mode: mode, index: idx, drag: 0 };
    view.setAttribute('data-cl-carousel', mode);
    view.clCar = car;
    return car;
  }

  function paint(car, extra) {
    if (car.mode === 'slide') {
      var d = -(car.lefts[car.index] - car.lefts[0]) + (extra || 0);
      car.slider.style.transform = car.base + ' translateX(' + d + 'px)';
    } else {
      car.cells.forEach(function (c, i) {
        c.style.opacity = i === car.index ? '1' : '0';
        c.style.pointerEvents = i === car.index ? '' : 'none';
        if (i === car.index) c.removeAttribute('aria-hidden');
        else c.setAttribute('aria-hidden', 'true');
      });
    }
    car.cells.forEach(function (c, i) {
      c.classList.toggle('is-selected', i === car.index);
    });
    syncThumbs(car);
    syncDots(car);
  }

  function go(car, i) {
    if (!car) return;
    car.index = Math.min(Math.max(i, 0), car.cells.length - 1);
    paint(car, 0);
  }

  function carOf(el) {
    var view = el.closest(VIEW_SEL);
    if (view && view.clCar) return view.clCar;
    var box = el.closest('.flickity-enabled, .hooper, .oke-mediaCarousel') || root(el);
    if (!box) return null;
    // setas compartilhadas entre abas (fora do .tab-content): o carrossel e o da aba ATUAL
    var cur = box.querySelector('.tab-content.current ' + VIEW_SEL);
    if (cur && cur.clCar) return cur.clCar;
    var v = box.querySelector(VIEW_SEL);
    return v && v.clCar ? v.clCar : null;
  }

  /* miniaturas: `[data-slideshow-thumbnail][data-media-select=ID]` -> celula
     `[data-media-id=ID]` da MESMA coluna de midia. */
  function galleryOf(el) {
    var wrap = el.closest('.product__media__wrapper') || root(el);
    if (!wrap) return null;
    var v = wrap.querySelector('[data-product-slideshow] ' + VIEW_SEL);
    return v && v.clCar ? v.clCar : null;
  }

  function syncThumbs(car) {
    var wrap = car.view.closest('.product__media__wrapper');
    if (!wrap) return;
    var id = car.cells[car.index].getAttribute('data-media-id');
    wrap.querySelectorAll('[data-slideshow-thumbnail]').forEach(function (t) {
      t.classList.toggle('is-activated', t.getAttribute('data-media-select') === id);
    });
  }

  function syncDots(car) {
    var box = car.view.parentElement;
    if (!box) return;
    var dots = box.querySelectorAll('.flickity-page-dots .dot');
    dots.forEach(function (d, i) { d.classList.toggle('is-selected', i === car.index); });
  }

  function scanCarousels() {
    document.querySelectorAll(SEC + ' ' + VIEW_SEL).forEach(function (view) {
      if (view.clCar) return;
      if (view.closest('[data-cl-pdp]')) return;   // buybox novo: galeria propria (cl-pdp.js)
      if (view.closest('[data-cl-own]')) return;   // secoes duplas: carrossel proprio (cl-orl.js)
      if (!view.getBoundingClientRect().width) return;
      var car = build(view);
      if (car) { CARS.push(car); paint(car, 0); attachDrag(car); }
    });
  }

  /* remede depois de trocar de viewport: a variante `.cl-vd`/`.cl-vm` que estava
     escondida media 0 e a que valia mudou de largura. */
  function remeasure() {
    CARS.length = 0;
    document.querySelectorAll(SEC + ' ' + VIEW_SEL).forEach(function (view) {
      if (view.clCar) {
        view.clCar.slider.style.transform = view.clCar.base;
        view.clCar = null;
        view.removeAttribute('data-cl-carousel');
      }
    });
    scanCarousels();
  }

  /* ------------------------------------------------------- arrasto/swipe ---
     Ponteiro unico (mouse ou dedo). Segue o dedo em `slide`; em `fade` so decide a
     direcao na soltura. */
  /* Instante em que um arrasto terminou de fato. Um <a> dentro da celula dispara
     `click` logo depois do `pointerup`; sem isto, arrastar a grade de produtos abriria
     a PDP do card sob o dedo. */
  var dragEndAt = 0;
  function nowMs() {
    return (window.performance && performance.now) ? performance.now() : (+new Date());
  }

  function attachDrag(car) {
    var startX = 0, startY = 0, active = false, moved = 0, locked = null;

    car.view.addEventListener('pointerdown', function (e) {
      if (e.button !== undefined && e.button !== 0) return;
      // Links NAO sao excluidos: as celulas das grades de produto sao <a> inteiras e o
      // flickity do concorrente arrasta por cima delas. O clique acidental no fim do
      // arrasto e barrado por `dragged` mais abaixo.
      if (e.target.closest('input, select, textarea, [contenteditable="true"]')) return;
      active = true; locked = null; moved = 0;
      startX = e.clientX; startY = e.clientY;
      car.view.classList.add('cl-dragging');
    });

    window.addEventListener('pointermove', function (e) {
      if (!active) return;
      var dx = e.clientX - startX;
      var dy = e.clientY - startY;
      if (locked === null) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        locked = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        if (locked === 'y') { active = false; car.view.classList.remove('cl-dragging'); return; }
      }
      moved = dx;
      e.preventDefault();
      if (car.mode === 'slide') paint(car, dx);
    }, { passive: false });

    function end() {
      if (!active) return;
      active = false;
      car.view.classList.remove('cl-dragging');
      var w = Math.abs(car.lefts[1] - car.lefts[0]) || car.view.clientWidth;
      var thr = car.mode === 'slide' ? Math.min(w / 3, 90) : 40;
      if (Math.abs(moved) > 6) dragEndAt = nowMs();
      if (moved <= -thr) go(car, car.index + 1);
      else if (moved >= thr) go(car, car.index - 1);
      else paint(car, 0);
      moved = 0;
    }
    window.addEventListener('pointerup', end);
    window.addEventListener('pointercancel', end);
  }

  /* setas: as do flickity (`.flickity-prev-next-button`), as da faixa de miniaturas
     (`[data-thumbs-arrow-prev|next]`) e as das abas do Pipeline. Quando nao existe
     carrossel congelado, a faixa e um scroller nativo — ai empurramos o scroll. */
  function step(btn, dir) {
    var car = carOf(btn);
    if (car) { go(car, car.index + dir); return; }
    var box = root(btn) || document;
    var scroller = btn.closest('.flickity-enabled, .hooper, [class*="__holder"], ' + SEC);
    scroller = (scroller && findScroller(scroller)) || findScroller(box);
    if (!scroller) return;
    var first = kids(scroller)[0];
    var sw = first ? first.getBoundingClientRect().width : scroller.clientWidth * 0.8;
    scroller.scrollBy({ left: dir * Math.max(40, sw), behavior: 'smooth' });
  }

  function findScroller(box) {
    var cands = [].slice.call(box.querySelectorAll('[data-grid], [data-product-thumbs], *'));
    for (var i = 0; i < cands.length; i++) {
      var e = cands[i];
      var s = getComputedStyle(e);
      if (/auto|scroll/.test(s.overflowX) && e.scrollWidth > e.clientWidth + 4) return e;
      if (/auto|scroll/.test(s.overflowY) && e.scrollHeight > e.clientHeight + 4
          && e.hasAttribute('data-product-thumbs')) return e;
    }
    return null;
  }

  /* ------------------------------------------------------------ buybox ---
     O botao "Ajouter au panier" copiado nao tem form valido (os ids de variante sao os
     da loja DELE). O form real e o do bloco nativo `buy_buttons`, escondido por CSS.
     Aqui lemos o tamanho marcado no radio copiado, casamos com a variante NOSSA
     (json emitido pelo bloco `b_map`) e disparamos o add + a gaveta do Shrine. */
  function ourVariants(host) {
    var el = host.querySelector('[data-cl-variants]')
      || document.querySelector('[data-cl-variants]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (err) { return null; }
  }

  function chosenLabel(box) {
    var r = box.querySelector('.radio__inputs input:checked, input[type="radio"]:checked');
    if (!r) return null;
    var lab = box.querySelector('label[for="' + (r.id || '') + '"]');
    var txt = (lab ? lab.textContent : (r.value || '')).trim();
    return txt.replace(/\s+/g, ' ');
  }

  function addToCart(btn) {
    var info = btn.closest('.product__info-container') || document;
    var box = root(btn) || info;
    var form = info.querySelector('product-form.main-product-form form, form[action*="/cart/add"]');
    if (!form) return false;
    var variants = ourVariants(info);
    var idInput = form.querySelector('[name="id"]');
    if (variants && idInput) {
      var want = chosenLabel(box);
      var hit = null;
      if (want) {
        hit = variants.filter(function (v) {
          return [v.title, v.option1, v.option2, v.option3].some(function (o) {
            return o && String(o).trim().toLowerCase() === want.toLowerCase();
          });
        })[0];
      }
      if (!hit) hit = variants.filter(function (v) { return v.available; })[0] || variants[0];
      if (hit) idInput.value = hit.id;
    }
    var qtyIn = box.querySelector('.quantity__input, input[name="quantity"]');
    var qty = parseInt(qtyIn && qtyIn.value, 10);
    if (isNaN(qty) || qty < 1) qty = 1;
    var vid = (idInput && idInput.value) || null;
    if (!vid) return false;

    // AJAX direto + abertura do cart drawer NATIVO do Shrine. `form.requestSubmit()`
    // nao e interceptado pelo <product-form> aqui (o form esta visualmente escondido) e
    // acabava navegando para /cart — o operador pediu gaveta lateral, nao pagina.
    btn.classList.add('loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(vid), quantity: qty }] })
    }).then(function (r) {
      return r.json();
    }).then(function () {
      return refreshCart();
    }).then(function () {
      openCartDrawer();
    }).catch(function () {
      window.location.href = '/cart';
    }).then(function () {
      btn.classList.remove('loading');
    });
    return true;
  }

  function refreshCart() {
    if (window.CLKC) return window.CLKC.refresh().catch(function () { return null; });
    return fetch('/?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        if (!sections) return;
        var draw = document.querySelector('cart-drawer');
        if (draw && sections['cart-drawer']) {
          var tmp = document.createElement('div');
          tmp.innerHTML = sections['cart-drawer'];
          var fresh = tmp.querySelector('cart-drawer');
          if (fresh) draw.innerHTML = fresh.innerHTML;
          draw.classList.remove('is-empty');
        }
        var bubble = document.querySelector('#cart-icon-bubble');
        if (bubble && sections['cart-icon-bubble']) {
          var t2 = document.createElement('div');
          t2.innerHTML = sections['cart-icon-bubble'];
          var fb = t2.querySelector('#cart-icon-bubble');
          if (fb) bubble.innerHTML = fb.innerHTML;
        }
      })
      .catch(function () { return null; });
  }

  function openCartDrawer() {
    if (window.CLKC) { window.CLKC.open(); return; }
    var d = document.querySelector('cart-drawer');
    if (!d) { window.location.href = '/cart'; return; }
    try {
      if (typeof d.open === 'function') { d.open(); return; }
    } catch (err) { /* segue para o fallback de classes */ }
    d.classList.add('animate', 'active');
    document.body.classList.add('overflow-hidden');
  }

  function stepQty(btn, dir) {
    var box = root(btn) || document;
    var input = box.querySelector('.quantity__input');
    if (!input) return;
    var v = parseInt(input.value, 10);
    if (isNaN(v)) v = 1;
    input.value = Math.max(1, v + dir);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-cl-pdp], .cl-pdp-modal-host')) return;   // buybox novo (cl-pdp.js) cuida de si
    if (nowMs() - dragEndAt < 300 && t.closest(SEC + ' [data-cl-carousel]')) {
      e.preventDefault(); e.stopPropagation(); return;   // fim de arrasto, nao e clique
    }
    var atc = t.closest(SEC + ' [data-add-to-cart], ' + SEC + ' .product__submit button, '
      + SEC + ' .product__submit [role="button"]');
    if (atc) { e.preventDefault(); e.stopPropagation(); addToCart(atc); return; }
    var cart = t.closest('a[href$="/cart"], a[href="/cart"], [data-drawer-toggle="drawer-cart"]');
    if (cart && (window.CLKC || document.querySelector('cart-drawer'))) {
      e.preventDefault(); openCartDrawer(); return;
    }
    var qm = t.closest(SEC + ' .quantity__button--minus');
    if (qm) { e.preventDefault(); stepQty(qm, -1); return; }
    var qp = t.closest(SEC + ' .quantity__button--plus');
    if (qp) { e.preventDefault(); stepQty(qp, 1); }
  }, true);

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-cl-pdp], .cl-pdp-modal-host')) return;   // buybox novo (cl-pdp.js) cuida de si

    var thumb = t.closest(SEC + ' [data-slideshow-thumbnail]');
    if (thumb) {
      e.preventDefault();
      var g = galleryOf(thumb);
      var id = thumb.getAttribute('data-media-select');
      if (g && id) {
        for (var i = 0; i < g.cells.length; i++) {
          if (g.cells[i].getAttribute('data-media-id') === id) { go(g, i); break; }
        }
      }
      return;
    }

    var dot = t.closest(SEC + ' .flickity-page-dots .dot');
    if (dot) {
      e.preventDefault();
      var cd = carOf(dot);
      if (cd) go(cd, [].indexOf.call(dot.parentElement.children, dot));
      return;
    }

    var link = t.closest(SEC + ' .tab-link');
    if (link) { e.preventDefault(); switchTab(link); return; }

    var head = t.closest(SEC + ' [aria-expanded][class*="accordion"], '
      + SEC + ' [aria-expanded][data-accordion-trigger]');
    if (head) { e.preventDefault(); toggleAccordion(head); return; }

    var next = t.closest(SEC + ' .flickity-next, ' + SEC + ' .flickity-prev-next-button.next, '
      + SEC + ' .tabs__arrow--next, ' + SEC + ' [data-scrollbar-arrow-next], '
      + SEC + ' [data-thumbs-arrow-next], ' + SEC + ' .oke-mediaCarousel-next, '
      + SEC + ' .hooper-next, ' + SEC + ' [class$="Carousel-next"]');
    if (next) { e.preventDefault(); step(next, 1); return; }

    var prev = t.closest(SEC + ' .flickity-prev-next-button.previous, '
      + SEC + ' .tabs__arrow--prev, ' + SEC + ' [data-scrollbar-arrow-prev], '
      + SEC + ' [data-thumbs-arrow-prev], ' + SEC + ' .oke-mediaCarousel-prev, '
      + SEC + ' .hooper-prev, ' + SEC + ' [class$="Carousel-prev"]');
    if (prev) { e.preventDefault(); step(prev, -1); }
  }, false);

  /* ---------------------------------------------------------------- boot ---
     Medir cedo demais pega imagem sem altura; medir so no `load` deixa o carrossel
     morto por segundos. Fazemos as duas coisas — a segunda passada refaz a medicao. */
  function boot() {
    syncAccordions();
    scanCarousels();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', function () { remeasure(); syncAccordions(); });

  var rz;
  window.addEventListener('resize', function () {
    clearTimeout(rz);
    rz = setTimeout(function () { remeasure(); syncAccordions(); }, 200);
  });
})();
